export default __webpack_public_path__ + "static/media/Health-Support-mobile-promo_580x340.887bbb1c.jpg";